import { getApiConfig } from '@/composable/useApi'
import type FutureEcom from '@futureecom/futureecom-js'

export let api: FutureEcom

export const configureApi = (clientId?: string, organisation?: number): FutureEcom => {
  api = getApiConfig(clientId, organisation)
  return api
}
